import { Play, RotateCcw } from 'lucide-react';
import { Button } from '../ui/button';

export const LoopVideoFallback = ({ playback, testId, label }) => {
  const { playing, canRun, blocked, error, start } = playback;
  if (playing || (canRun && !blocked && !error)) return null;
  return <div className="loop-video-fallback" data-testid={`${testId}-fallback`}>
    {error && <p role="alert" className="loop-video-error" data-testid={`${testId}-error`}>Das Video konnte nicht geladen werden. Bitte starten Sie es erneut.</p>}
    <Button type="button" variant="outline" className="loop-video-start" data-testid={`${testId}-start`} aria-label={`${label} ${error ? 'erneut starten' : 'starten'}`} onClick={start}>
      {error ? <RotateCcw size={14} /> : <Play size={14} />}
      {error ? 'Erneut starten' : 'Video starten'}
    </Button>
  </div>;
};